<template>
    <div class="flex items-start justify-center">
        <div class="px-8 py-6 mt-4 text-left bg-white shadow-md max-w-md w-full">
            <h1 class="text-2xl font-medium">Login</h1>
            <div class="bg-red-50 border-l-4 border-red-500 text-black p-2 mt-2" v-show="error" transition="fade">
                {{ error }}
            </div>
            <form class="mt-4 space-y-4" @submit.prevent="login">
                <text-input v-model="creds.email" name="email" label="Email" />
                <text-input type="password" v-model="creds.password" name="password" label="Password" />
                <div class="space-x-4">
                    <primary-button>Login</primary-button>
                    <router-link to="/ForgotPassword" class="text-sm underline">Forgot Password</router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

import auth from '../../services/Client/Auth';
import TextInput from "../Form/TextInput.vue";
import PrimaryButton from "../Form/PrimaryButton";

export default {

    components: { PrimaryButton, TextInput },

    data () {
        return {
            creds: {
                email: '',
                password: ''
            },
            error: ''
        }
    },

    methods: {
        login () {
            const router = this.$router;
            auth.login(this.creds, function(err, success) {

                if (err || !success) {
                    this.error = err;
                    this.creds.password = '';
                } else {
                  router.push({ path: localStorage.getItem('prevPage') || '/' });
                }
            }.bind(this));

        }
    },

    route: {
        activate () {
            this.error = null;
        }
    }
}
</script>
